import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authActionLogin, dataTaggerActionClearAll, memoActionDelAll, sequenceActionReset } from '@laramie/ui';
import { completeSsoLogin } from '../../utils/sso';
import HeaderBasic from '../../components/layout/HeaderBasic';

function SsoCallbackView() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        const fail = (message) => navigate(`/login?sso_error=${encodeURIComponent(message)}`, { replace: true });

        if (params.get('error')) {
            fail(params.get('error_description') || params.get('error'));
            return;
        }
        const code = params.get('code');
        if (!code) {
            navigate('/login', { replace: true });
            return;
        }

        completeSsoLogin(code, params.get('state'))
            .then(({ token, username }) => {
                // Como el login clásico, sin pasar el token por la dirección: con la sesión iniciada, PublicRoute
                // lleva a /welcome, que elige el módulo según los permisos.
                dispatch(memoActionDelAll());
                dispatch(dataTaggerActionClearAll());
                dispatch(sequenceActionReset());
                dispatch(authActionLogin(username, token));
            })
            .catch(e => fail(e.message || 'No se pudo iniciar sesión'));
    }, []);

    return (
        <div>
            <HeaderBasic showMenu={false} />
            <div className='bg-img'>
                <div className="login-container">
                    <section className='lg-c'>
                        <p>Ingresando…</p>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default SsoCallbackView;
